import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap} from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.sass'],
})
export class ErrorComponent implements OnInit {
  statusCode?: string;
  message?: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.statusCode = params.get('status') ?? '';
    });
    if (this.statusCode == '404') {
      this.message = 'A keresett oldal nem található!';
    } else if (this.statusCode == '403') {
      this.message = 'Nincs jogosultsága a keresett oldal megtekintéséhez!';
    } else if (this.statusCode == '500') {
      this.message = 'Váratlan hiba történt!';
    } else {
      this.message = 'Váratlan hiba történt!';
    }
  }
}
